import { cn } from '~/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        `
          flex min-h-20 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs
          transition-[color,box-shadow] outline-none
          selection:bg-primary selection:text-primary-foreground
          placeholder:text-muted-foreground
          disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
          md:text-sm
          dark:bg-input/30
        `,
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        className,
      )}
      data-slot="textarea"
      {...props}
    />
  )
}

export { Textarea }
